import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

class OptionsAuto {
  constructor(id, label) {
    this.id = id;
    this.label = label;
  }
}

function MuiAutoComplete(params) {
  const [value, setValue] = React.useState('');
  const [inputValue, setInputValue] = React.useState('');

  const datos = params.productos.map(producto => new OptionsAuto(producto.codigo, producto.nombre));

  function getInputChange(newInputValue) {
    setInputValue(newInputValue);
  }

  function getOnchange(newValue) {
    setValue(newValue);
    setTimeout(buscar, 100);
  }

  function buscar() {
    document.getElementById('inputHiddenValue').click();
    setValue('');
  }

  function submitHandler(e) {
    e.preventDefault();
  }

  return (
    <div>
      <input type="hidden" onClick={params.clickComplete} value={inputValue} id="inputHiddenValue" />
      <form onSubmit={submitHandler} id="formAutocomplete" className="form-inline">
        <div className="input-group">
          <Autocomplete className="fondoBlanco rounded"
            disablePortal
            id="combo-box-demo"
            value={value}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} InputLabelProps={{ style: { color: 'black' } }} label="Buscar..." size="small" />}
            onChange={(_, newValue) => {
              getOnchange(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(_, newInputValue) => {
              getInputChange(newInputValue);
            }}
            options={datos}
            filterOptions={(options, state) => {
              const inputValue = state.inputValue.toLowerCase();
              return options.filter(option => {
                const optionLabel = option.label.toLowerCase();
                // Opción 1: Coincidencia de la palabra completa (ej. "sabana" en "juego de sabana")
                if (optionLabel.includes(inputValue)) {
                  return true;
                }
                // Opción 2: Coincidencia inversa para singular/plural (ej. "sabanas" y "sabana")
                if (inputValue.endsWith('s')) {
                  const singularInput = inputValue.slice(0, -1);
                  if (optionLabel.includes(singularInput)) {
                    return true;
                  }
                }
                // Opción 3: Coincidencia inversa para palabras más cortas
                if (inputValue.length > 2 && optionLabel.includes(inputValue.slice(0, -1))) {
                    return true;
                }

                return false;
              });
            }}
            getOptionLabel={(option) => {
              if (typeof option === 'string') {
                return option;
              }
              return option.label;
            }}
            freeSolo
          />
          <button className='fondoBeige rounded' type='button' onClick={buscar}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
}

export default MuiAutoComplete;
